/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface IAddressDetailItem {
    isNewLine: boolean;
    isShowLabel: boolean;
    labelText: string;
    name: string;
    value: string;
}

/**
 * Address details item.
 * @param props - Configuration of the functional component.
 * @returns React functional component.
 */
export const AddressDetailItemFunctionComponent: React.FC<IAddressDetailItem> = (props: IAddressDetailItem) => {
    const { labelText, value } = props;

    const className = `ms-checkout-delivery-options__cart-line-grp__item__header__address`;
    return (
        <span className={`${className}`}>
            <span className={`${className}-label`}>{labelText}</span>
            <span className={`${className}-value`}>{value}</span>
        </span>
    );
};

export default AddressDetailItemFunctionComponent;
